import { createRoute } from '@tanstack/react-router'
import { rootRoute } from 'router/root-route'
import { z } from 'zod'

import { OrderRedirect } from '../components/OrderRedirect'

const searchSchema = z.object({
  auth_code: z.string(),
  state: z.string()
})

export const orderRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/order-redirect',
  component: OrderRedirect,
  validateSearch: searchSchema
})
